// Sinal global de "o modal de detalhe de uma negociação está aberto agora".
//
// NegotiationDetailModal.tsx é instanciado de forma independente em várias telas
// (KanbanBoard, TarefasView, RotasView, AnalyticsComercialView, DashboardHome,
// MapaLeadsView, CRMLayout), cada uma com seu próprio estado local de isOpen — não
// existe hoje nenhum lugar único que saiba "tem um modal de detalhe aberto".
//
// Em vez de instrumentar cada ponto de abertura, o próprio NegotiationDetailModal
// dispara este evento a cada mudança de `isOpen` (ver o useEffect nele) — cobre
// todas as telas de graça. Usado pelo LeadAssignedPopup pra represar o aviso de
// novo lead enquanto o usuário está com um modal de detalhe aberto (não pode
// interromper o fluxo).

import { useEffect, useState } from 'react';

const EVENTO = 'vigorhub:negotiation-detail-modal';

export interface NegotiationModalSignalDetail {
    aberto: boolean;
    negociacaoId: number | null;
}

export const dispararSinalModalDetalhe = (detail: NegotiationModalSignalDetail): void => {
    window.dispatchEvent(new CustomEvent<NegotiationModalSignalDetail>(EVENTO, { detail }));
};

const ouvirSinalModalDetalhe = (cb: (detail: NegotiationModalSignalDetail) => void): (() => void) => {
    const handler = (e: Event) => cb((e as CustomEvent<NegotiationModalSignalDetail>).detail);
    window.addEventListener(EVENTO, handler);
    return () => window.removeEventListener(EVENTO, handler);
};

/** true enquanto algum NegotiationDetailModal estiver aberto em qualquer tela do app. */
export const useModalDetalheAberto = (): boolean => {
    const [aberto, setAberto] = useState(false);
    useEffect(() => ouvirSinalModalDetalhe((d) => setAberto(d.aberto)), []);
    return aberto;
};
